<template> 
  <b-form @submit.stop.prevent="submit">
    <b-form-group label="Title" label-for="snippetTitle">
      <b-form-input v-model="form.title" id="snippetTitle" required></b-form-input>
    </b-form-group>
  
    <div class="full" ref="full">
      <div class="editor">
        <QuillEditor v-model="form.body"></QuillEditor>
      </div>

      <div class="d-grid gap-2 mt-4">
        <div @click="toggle" v-if="fullscreen" class="btn btn-secondary">Toggle fullscreen</div>
      </div>
    </div>

    <div class="d-flex flex-row-reverse">
      <b-button type="submit" variant="primary">Save</b-button>
    </div>
  </b-form>
</template>

<script>
  import gql from 'graphql-tag'

  import screenfull from 'screenfull';

  import QuillEditor from '../../components/QuillEditor';

  const CREATE_SNIPPET = gql`
    mutation CreateSnippet($input: snippets_insert_input!) {
      snippet: insert_snippets_one(object: $input) {
        id
        title
        body
        created_at
        updated_at
      }
    }
  `;

  const UPDATE_SNIPPET = gql`
    mutation UpdateSnippet($id: uuid!, $input: snippets_set_input!) {
      snippet: update_snippets_by_pk(
        pk_columns: { id: $id },
        _set: $input
      ) {
        id
        title
        body
        created_at
        updated_at
      }
    }
  `;

  export default {
    props: ['id', 'snippet'],

    components: {
      QuillEditor
    },

    data() {
      return {
        form: this.initForm(),

        authors: [
          'Bro. Roger Smith',
          'Bro. Greg Patterson',
          'Bro. Mike Geransky'
        ],

        datepicker: {
          disabledDates: {
            days: [1, 2, 4, 5]
          }
        },

        fullscreen: screenfull.isEnabled
      }
    },

    watch: {
      form: {
        handler() {
          this.$emit('changed');
        },

        deep: true
      }
    },

    methods: {
      initForm() {
        return {
          title: this.snippet && this.snippet.title,
          body: this.snippet && this.snippet.body || ''
        }
      },

      toggle() {
        screenfull.toggle(this.$refs.full);
      },

      submit() {
        if (this.snippet) {
          this.update();
        } else {
          this.create();
        }
      },

      create() {
        this.$apollo.mutate({
          mutation: CREATE_SNIPPET,

          variables: {
            input: this.form
          },

          update: (cache, { data }) => {
            this.form = this.initForm();
            this.$emit('saved', data.snippet, { cache });
          }
        })
      },

      update() {
        const id = this.$props.snippet.id;
        
        this.$apollo.mutate({
          mutation: UPDATE_SNIPPET,

          variables: {
            id,
            input: this.form
          }
        }).then(({ data }) => {
          this.$emit('saved', data.snippet, {})
        })
      }
    }
  }
</script>

<style>
  @import '~@sum.cumo/vue-datepicker/dist/Datepicker.css';

  .editor {
    height: 250px;
  }

  .full:fullscreen .editor {
    height: calc(100vh - 4rem);
  }

  .full {
    padding: 1rem 0;
  }

  .full:fullscreen {
    background: #fff;
    padding: 1rem;
  }
</style>